// extracted by mini-css-extract-plugin
export default {"marquee_container":"marqueeSlider_marquee_container__lpILu","marqueeSlide":"marqueeSlider_marqueeSlide__GIpW8"};